import { AdminPanelContent } from "./AdminPanelContent"


export const AdminPanelContainer = () => {

    return (
        <AdminPanelContent title = {'Панель администратора'} desc={'Здесь вы можете отредактировать пользователей'}/>
    )
}